import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Scene from '../3D/Scene';

// Spacer de 100vh al capdamunt de la Home. El seu progrés connecta amb la POSICIÓ (Y+Z) del
// character: setCharacterIntroProgress(0→1). S'usa progressTop perquè per un item al capdamunt
// (top≈0, height 100vh) va 0→1 exactament quan Scroll.y va de 0 a l'alçada del spacer.
// La intro (scroll programàtic de la Home) fa avançar aquest progrés → el character "entra".
class ScrollItem__WidgetHomeSpacer extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.onShow = () => { };
        this.onHide = () => { };
        this.onMove = () => {
            Scene.setCharacterIntroProgress(Maths.clamp(this.progressTop, 0, 1));
        };
    }
}

Scroll._registerClass('WidgetHomeSpacer', ScrollItem__WidgetHomeSpacer);

export default ScrollItem__WidgetHomeSpacer;
